<section>
    <div class="block">
        <div class="title-tab-step">
            {{ 'PATIONTSEARCH' | translate }}
            <i *ngIf="allowAddPat != false" class="fa fa-plus fa-1x custom-add-btn" aria-hidden="true"
                title="{{ 'addnewPatient' | translate }}" (click)="goToAddPatient(false)"></i>
        </div>
        <div class="row m-0" *ngIf="fixedBillNotExtracted !=1">
            <div class="col p-0">
                <app-fast-search
                    [appCodes]="[2000,8086,8019,1020,8117,8118,8119,2001,2002,2003,1,1013,1040,82,7,35,1099,505,1481,2021,2006]"
                    [searchType]="PatientParms" [specificAppCodes]="[2000,2003,2002]" (toggle)="togglefillter()"
                    (searchKeys)="onSearchClick($event)" ngDefaultControl>
                </app-fast-search>
            </div>
        </div>
        <div class="row m-0" *ngIf="fixedBillNotExtracted ==1">
            <div class="col p-0">
                <app-fast-search [preventEmptySearch]="true"
                    [appCodes]="[2000,2021,2006,8019,1020,2001,2002,1040,82,35,1099,505]" [searchType]="PatientParms"
                    (toggle)="togglefillter()" (searchKeys)="onSearchClick($event)" ngDefaultControl>
                </app-fast-search>
            </div>
        </div>
    </div>
    <div class="row m-0 p-0 mt-2">
        <div class="table-responsive" [ngClass]="{'col-md-12 p-0':!isHistory,'col-md-6':isHistory}">
            <p-dataTable tableStyleClass="table table-bordered table-striped ui-state-highlight" [value]="patients"
                selectionMode="single" [rows]="20" [totalRecords]="totalRecords" [lazy]="true"
                (onPage)="paginate($event)" (onRowClick)="onRowSelect($event)" [paginator]="true" [pageLinks]="3"
                [rowsPerPageOptions]="[5,10,20,50,100]">

                <p-column [style]="{'width': '8%'}" header="{{ 'MRN' | translate }}" [sortable]="true">
                    <ng-template pTemplate="options" let-row="rowData">
                        <span style="text-decoration: line-through double red;" *ngIf="row.mergedFlag == 1">
                            {{row.customCode}}
                        </span>
                        <span *ngIf="row.mergedFlag != 1">
                            {{row.customCode}}
                        </span>
                        <span *ngIf="row.mergedFlag == 1">
                            {{row.mergedByPatCode}}

                        </span>

                    </ng-template>
                </p-column>
                <!-- [ngClass]="{text-success:  row['oldCode']}" -->
                <!-- <p-column [style]="{'width': '27%'}" field="{{translate.currentLang == 'ar' ? 'fullnameAr':'fullnameEn'}}" header="{{ 'Name' | translate }}" [sortable]="true"></p-column> -->
                <p-column [style]="{'width': '27%'}" header="{{ 'Name' | translate }}" [sortable]="true">
                    <ng-template pTemplate="options" let-row="rowData">
                        <mat-icon class="custom-icon"
                            [matTooltip]="row.identityValNphiesDisplay + ':' + row.identityValue"
                            style="display: inline; cursor: pointer;" (click)="copyTextToClipboard(row.identityValue)">
                            {{ translate.currentLang == 'ar' ? row.oldCodeFullnameAr : row.oldCodeFullnameEn }}
                        </mat-icon>
                    </ng-template>
                </p-column>
                <p-column [style]="{'width': '8%'}" field="gender" header="{{ 'GENDER' | translate }}"
                    [sortable]="true">
                    <ng-template pTemplate="options" let-row="rowData">
                        <img style="width:25px; height:25px;" src="../../../assets/images/Gender{{row['gender']}}.png"
                            data-toggle="tooltip" data-placement="bottom"
                            title="{{translate.currentLang == 'ar'? row['gender_name_ar'] : row['gender_name_ar']}}" />
                    </ng-template>

                </p-column>

                <p-column [style]="{'width': '17%'}" header="{{ 'ArabicFullAddress' | translate }}" [hidden]="isHistory"
                    [sortable]="true">
                    <ng-template pTemplate="options" let-row="rowData">
                        <div>
                            {{ translate.currentLang == 'ar' ? row.fullAddressAr: row.fullAddressEn }}
                        </div>
                    </ng-template>
                </p-column>

                <p-column [style]="{'width': '8%'}" field="mobile" header="{{ 'MOBILENUMBER' | translate }}">
                </p-column>

                <p-column [style]="{'width': '8%'}" field="nationalityId" header="{{ 'NATIONALITY' | translate }}">
                    <ng-template pTemplate="options" let-row="rowData">
                        <div class="flag flag-{{row['countryFlag']}}" data-toggle="tooltip" *ngIf="row.nationalityId"
                            data-placement="bottom"
                            title="{{translate.currentLang == 'ar'? row['nationalityAr'] : row['nationalityEn']}}">
                        </div>
                    </ng-template>
                </p-column>

                <p-column [style]="{'width': '14%'}" field="birthDate" header="{{ 'BIRTHDATE' | translate }}"
                    [sortable]="true">
                    <ng-template pTemplate="options" let-row="rowData">
                        {{row['dob'] }}
                    </ng-template>
                </p-column>

                <p-column [style]="{'width': '14%'}" field="birthDate" header="{{ 'NOTES' | translate }}"
                    [sortable]="true">
                    <ng-template pTemplate="options" let-row="rowData">
                        {{row['drGeneralNotes'] }}
                    </ng-template>
                </p-column>
                <p-column [style]="{'width': '5%'}">
                    <ng-template pTemplate="options" let-row="rowData">
                        <div>
                            <i *ngIf="row.stopFlag == 1" class="fa fa-ban  fa-2 fa-danger " aria-hidden="true"
                                data-toggle="tooltip" data-placement="bottom"
                                title="{{translate.currentLang == 'ar'? row['stopReson_name_ar'] +' '+   row['patStopDealNotes']  :row['stopReson_name_en'] +' '+ row['patStopDealNotes']}}"></i>
                        </div>

                    </ng-template>
                </p-column>
                <p-column field="chronic" header="{{ 'CHRONIC' | translate }}">
                    <ng-template pTemplate="options" let-row="rowData">
                        <i class="fa dataTableFa"
                            [ngClass]="{'fa-check-square chronic': row['chronic'] == 1,'fa-square-o':row['chronic'] != 1}"></i>
                    </ng-template>
                </p-column>
                <p-column field="infection" header="{{ 'INFECTION' | translate }}">
                    <ng-template pTemplate="options" let-row="rowData">
                        <i class="fa dataTableFa"
                            [ngClass]="{'fa-check-square chronic ': row['infection'] == 1,'fa-square-o':row['infection'] != 1}"></i>
                    </ng-template>
                </p-column>


                <p-column [style]="{'width': '5%'}">
                    <ng-template pTemplate="options" let-row="rowData">
                        <div>
                            <i *ngIf="row.duplicatSessionStopflage == 1" class="fa fa-ban  fa-2 fa-danger "
                                aria-hidden="true" data-toggle="tooltip" data-placement="bottom"
                                title="{{translate.currentLang == 'ar'?   'ايقاف تكرار الجلسات'  : 'duplicat Session Stop' }}"></i>
                        </div>

                    </ng-template>
                </p-column>

                <!-- <p-column [style]="{'width': '8%'}" field="mergedByPatCode" header="{{ 'MERGEDCODE' | translate }}" [sortable]="true"></p-column>
                <p-column  header="{{ 'MERGEDNAME' | translate }}" [sortable]="true">
                    <ng-template pTemplate="options" let-row="rowData">
                        <div>
                            {{ translate.currentLang == 'ar' ? row.mergedPatNameAr : row.mergedPatNameEn }}
                        </div>
                    </ng-template>
                </p-column> -->
                <p-column *ngIf="RadStep" [style]="{'width': '5%'}" header="{{ 'PATIENTSERVICES' | translate }}">
                    <ng-template pTemplate="options" let-row="rowData">
                        <icon-action (clicked)="ShowPatientService($event,row)" [parentUIKey]="'1'" [appCodes]="[201]">
                        </icon-action>
                    </ng-template>
                </p-column>
                <p-column [style]="{'width': '5%'}" header="{{ 'ACTIONS' | translate }}">
                    <ng-template *ngIf="!isHistory" pTemplate="options" let-row="rowData">
                        <icon-action *ngIf="parent!='InpatientExit'  " (clicked)="onRowClick($event,row)"
                            [parentUIKey]="'1'" [appCodes]="[202,201,203,32,2121,2416,6706,2132 ,6963,7350,6500,7384]">
                        </icon-action>
                        <icon-action *ngIf="parent=='InpatientExit'" (clicked)="onRowClick($event,row)"
                            [parentUIKey]="'1'" [appCodes]="[6412]">
                        </icon-action>

                    </ng-template>
                    <ng-template *ngIf="isHistory" pTemplate="options" let-row="rowData">
                        <icon-action (clicked)="onRowClick($event,row)" [parentUIKey]="'1'"
                            [appCodes]="[201, 2132,7350,6500]">
                        </icon-action>
                    </ng-template>
                </p-column>




            </p-dataTable>
        </div>
        <div class="col-md-6" [hidden]="!isHistory">
            <OutPatReservation-visitsHistory (emitUnCompress)="hideVisitHistory($event)"
                (emitSelectedVisit)="selectVisit($event)" [patient]="patient">
            </OutPatReservation-visitsHistory>
        </div>
        <div class="row ">

            <block-modal-container #popup (close)="onpopupClose($event)">
                <ng-container class="modal-body" [ngComponentOutlet]="dynamicComponent"></ng-container>
            </block-modal-container>
            <block-modal-container #popup2 (close)="onpopupClose($event)">
                <ng-container class="modal-body">
                    <div *ngIf="dynamicComponent == 3">

                        <sanabel-files-upload [multiple]="true" [patientVisitCode]="actionRowData.lastVisitSerial"
                            [patientCode]="actionRowData.patientCode">
                        </sanabel-files-upload>
                    </div>
                </ng-container>
            </block-modal-container>

        </div>
    </div>
    <app-service-history *ngIf="RadStep"></app-service-history>
</section>